import styled from "styled-components";

const WrapPosition = styled.div`
  position: absolute;
  ${(props) => props.pos.left && `left: ${props.pos.left};`}
  ${(props) => props.pos.top && `top: ${props.pos.top};`}
  ${(props) => props.pos.width && `width: ${props.pos.width};`}
  ${(props) => props.pos.addPosCss && `${props.pos.addPosCss}`}
`;

const TextContents = styled.div`
  white-space: pre-wrap;
  width: 100%;
  font-variant: normal;

  ${(props) =>
    props.fontStyle &&
    props.fontStyle.family &&
    `font-family: ${props.fontStyle.family};`}
  ${(props) =>
    props.fontStyle &&
    props.fontStyle.size &&
    `font-size: ${props.fontStyle.size};`}
${(props) =>
    props.fontStyle &&
    props.fontStyle.textAlign &&
    `text-align: ${props.fontStyle.textAlign};`}
${(props) => props.addStyle}

${(props) =>
    props.fontStyle &&
    props.fontStyle.limitStyle &&
    `@media (min-width:600px){
  ${props.fontStyle.limitStyle};
}`}
`;

export { WrapPosition, TextContents };



// WEBPACK FOOTER //
// ./src/components/preview/TextItem.styled.tsx